/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fw_Pub_Field_SummaryInputs */

const en_fw_pub_field_summary = /** @type {(inputs: Fw_Pub_Field_SummaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Summary`)
};

const id_fw_pub_field_summary = /** @type {(inputs: Fw_Pub_Field_SummaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ringkasan`)
};

/**
* | output |
* | --- |
* | "Summary" |
*
* @param {Fw_Pub_Field_SummaryInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const fw_pub_field_summary = /** @type {((inputs?: Fw_Pub_Field_SummaryInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fw_Pub_Field_SummaryInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_fw_pub_field_summary(inputs)
	return en_fw_pub_field_summary(inputs)
});